module.exports = "/_next/static/images/58bad9706017f7a8b8bd0112f23526dd-circles.svg.webp";